import { Component } from '@angular/core';
import { UnderDevelopmentComponent } from "@shared/components/under-development/under-development.component";

@Component({
  selector: 'app-demo',
  imports: [UnderDevelopmentComponent],
  templateUrl: './demo.html',
  styleUrl: './demo.scss'
})
export class Demo {

}
